export default __webpack_public_path__ + "static/media/grey-like-icon.d0d8b7bb.svg";